(function () {
  'use strict';

  function normalize(str) {
    return (str || '').toLowerCase().replace(/[-\s_]/g, '');
  }

  function getMainSwiper() {
    var el = document.querySelector(
      '.product__media-gallery .swiper, ' +
      '.product-media-gallery .swiper, ' +
      '[data-product-media-gallery] .swiper, ' +
      'media-gallery .swiper'
    );
    return el && el.swiper ? el.swiper : null;
  }

  function getThumbSwiper() {
    var el = document.querySelector(
      '.product__media-gallery .swiper-thumbs, ' +
      '.product-thumbnails .swiper, ' +
      '.swiper-thumbs'
    );
    return el && el.swiper ? el.swiper : null;
  }

  function jumpToColor(colorValue) {
    if (!colorValue) return;
    var color = normalize(colorValue);

    var mainSwiper = getMainSwiper();
    if (!mainSwiper) return;

    var isLoop = mainSwiper.params && mainSwiper.params.loop;
    var slides = mainSwiper.slides;
    var targetRealIndex = -1;

    for (var i = 0; i < slides.length; i++) {
      // loop 模式下跳过克隆的 slide
      if (slides[i].classList.contains('swiper-slide-duplicate')) continue;

      var img = slides[i].querySelector('img');
      if (!img) continue;

      var alt = normalize(img.alt);
      if (alt && (alt === color || alt.includes(color))) {
        // 取 realIndex（loop 模式下克隆 slide 没有这个属性）
        var ri = parseInt(slides[i].getAttribute('data-swiper-slide-index'));
        targetRealIndex = isNaN(ri) ? i : ri;
        break;
      }
    }

    if (targetRealIndex === -1) return;

    if (isLoop) {
      mainSwiper.slideToLoop(targetRealIndex, 300);
    } else {
      mainSwiper.slideTo(targetRealIndex, 300);
    }

    var thumbSwiper = getThumbSwiper();
    if (thumbSwiper) {
      if (thumbSwiper.params && thumbSwiper.params.loop) {
        thumbSwiper.slideToLoop(targetRealIndex, 300);
      } else {
        thumbSwiper.slideTo(targetRealIndex, 300);
      }
    }
  }

  function getSelectedColor() {
    var checked = document.querySelector('input[name^="Color-"]:checked');
    return checked ? checked.value : null;
  }

  var timer = null;
  function debouncedJump(color) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      jumpToColor(color);
    }, 60);
  }

  function init() {
    document.addEventListener('change', function (e) {
      if (e.target.name && e.target.name.startsWith('Color-')) {
        debouncedJump(e.target.value);
      }
    });

    document.addEventListener('variant:change', function () {
      var color = getSelectedColor();
      if (color) debouncedJump(color);
    });

    setTimeout(function () {
      var color = getSelectedColor();
      if (color) jumpToColor(color);
    }, 900);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
